/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BasicContestantInfoDTO,
  BasicRegisteredContestantSelectionsDTO,
  BooleanResponseWrapper,
  BulkContestantSelectionUpdateRequestDTO,
  CompletePageantRegistrationDTOListResponseWrapper,
  CompletePageantRegistrationDTOResponseWrapper,
  ContestantAgeGroupSupremeGroupsResult,
  PageantAgeGroupBaseModel,
  PageantRegistrationRequest,
  PictureModel,
  RegisteredPageantContestantBaseModelIEnumerableResponseWrapper,
  RegisteredPageantContestantModelResponseWrapper,
  UpdateFieldsRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PageantRegistration<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetPageantRegistrationById
   * @request GET:/PageantRegistration/GetPageantRegistrationById:{pageantRegistrationId}
   */
  getPageantRegistrationById = (pageantRegistrationId: number, params: RequestParams = {}) =>
    this.request<RegisteredPageantContestantModelResponseWrapper, any>({
      path: `/PageantRegistration/GetPageantRegistrationById:${pageantRegistrationId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetAllRegistrationsForPageant
   * @request GET:/PageantRegistration/{pageantId}/all-registrations
   */
  getAllRegistrationsForPageant = (pageantId: number, params: RequestParams = {}) =>
    this.request<RegisteredPageantContestantBaseModelIEnumerableResponseWrapper, any>({
      path: `/PageantRegistration/${pageantId}/all-registrations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetAllRegistrationsByPageantId
   * @request GET:/PageantRegistration/AllPageantRegistrationsByPageantId:{pageantId}
   */
  getAllRegistrationsByPageantId = (pageantId: number, params: RequestParams = {}) =>
    this.request<RegisteredPageantContestantBaseModelIEnumerableResponseWrapper, any>({
      path: `/PageantRegistration/AllPageantRegistrationsByPageantId:${pageantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetCompleteRegistrationForContestant
   * @request GET:/PageantRegistration/CompleteRegisteredContestant:{registeredContestantId}
   */
  getCompleteRegistrationForContestant = (registeredContestantId: number, params: RequestParams = {}) =>
    this.request<CompletePageantRegistrationDTOResponseWrapper, any>({
      path: `/PageantRegistration/CompleteRegisteredContestant:${registeredContestantId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetCompleteRegistrationsForPageant
   * @request GET:/PageantRegistration/{pageantId}/complete-registrations
   */
  getCompleteRegistrationsForPageant = (pageantId: number, params: RequestParams = {}) =>
    this.request<CompletePageantRegistrationDTOListResponseWrapper, any>({
      path: `/PageantRegistration/${pageantId}/complete-registrations`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetBasicContestantInfoForPageant
   * @request GET:/PageantRegistration/{pageantId}/basic-contestant-info
   */
  getBasicContestantInfoForPageant = (pageantId: number, params: RequestParams = {}) =>
    this.request<BasicContestantInfoDTO[], any>({
      path: `/PageantRegistration/${pageantId}/basic-contestant-info`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetContestantSelectionsByPageant
   * @request GET:/PageantRegistration/{pageantId}/registrations/{pageantRegistrationId}/selections
   */
  getContestantSelectionsByPageant = (pageantId: number, pageantRegistrationId: number, params: RequestParams = {}) =>
    this.request<BasicRegisteredContestantSelectionsDTO, any>({
      path: `/PageantRegistration/${pageantId}/registrations/${pageantRegistrationId}/selections`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetAllRegisteredContestantSelectionsByPageant
   * @request GET:/PageantRegistration/{pageantId}/all-registrations/selections
   */
  getAllRegisteredContestantSelectionsByPageant = (pageantId: number, params: RequestParams = {}) =>
    this.request<BasicRegisteredContestantSelectionsDTO, any>({
      path: `/PageantRegistration/${pageantId}/all-registrations/selections`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name BulkUpdateContestantSelections
   * @request POST:/PageantRegistration/bulk-update-contestant-selections
   */
  bulkUpdateContestantSelections = (data: BulkContestantSelectionUpdateRequestDTO, params: RequestParams = {}) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/PageantRegistration/bulk-update-contestant-selections`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name AddPageantRegistration
   * @request POST:/PageantRegistration
   */
  addPageantRegistration = (data: PageantRegistrationRequest, params: RequestParams = {}) =>
    this.request<RegisteredPageantContestantModelResponseWrapper, any>({
      path: `/PageantRegistration`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name PatchPageantRegistration
   * @request PATCH:/PageantRegistration
   */
  patchPageantRegistration = (data: PageantRegistrationRequest, params: RequestParams = {}) =>
    this.request<RegisteredPageantContestantModelResponseWrapper, any>({
      path: `/PageantRegistration`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetAgeRange
   * @request PATCH:/PageantRegistration/GetAgeRange
   */
  getAgeRange = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format date-time */
      birthday?: string;
      takenFallback?: boolean;
      moveUpAgeGroup?: boolean;
      /** @format int32 */
      divisionId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAgeGroupBaseModel, any>({
      path: `/PageantRegistration/GetAgeRange`,
      method: 'PATCH',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetSupremeGroups
   * @request PATCH:/PageantRegistration/GetSupremeGroups
   */
  getSupremeGroups = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format date-time */
      birthday?: string;
      takenFallback?: boolean;
      moveUpAgeGroup?: boolean;
      /** @format int32 */
      divisionId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAgeGroupBaseModel[], any>({
      path: `/PageantRegistration/GetSupremeGroups`,
      method: 'PATCH',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name GetAgeRangeAndSupremeGroups
   * @request PATCH:/PageantRegistration/GetAgeRangeAndSupremeGroups
   */
  getAgeRangeAndSupremeGroups = (
    query?: {
      /** @format int32 */
      pageantRegistrationId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<ContestantAgeGroupSupremeGroupsResult, any>({
      path: `/PageantRegistration/GetAgeRangeAndSupremeGroups`,
      method: 'PATCH',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name CalculateAndAssignAgeAndSuprmeGroups
   * @request PATCH:/PageantRegistration/CalculateAndAssignAgeAndSuprmeGroups
   */
  calculateAndAssignAgeAndSuprmeGroups = (
    query?: {
      /** @format int32 */
      pageantRegistrationId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<ContestantAgeGroupSupremeGroupsResult, any>({
      path: `/PageantRegistration/CalculateAndAssignAgeAndSuprmeGroups`,
      method: 'PATCH',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name DeletePageantRegistration
   * @request DELETE:/PageantRegistration/{pageantRegistrationId}
   */
  deletePageantRegistration = (pageantRegistrationId: number, params: RequestParams = {}) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/PageantRegistration/${pageantRegistrationId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name PatchPageantRegistrationResultsVisibility
   * @request PATCH:/PageantRegistration/saveResultVisibility
   */
  patchPageantRegistrationResultsVisibility = (
    query?: {
      /** @format int32 */
      pageantRegistrationId?: number;
      isResultsPrivate?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<RegisteredPageantContestantModelResponseWrapper, any>({
      path: `/PageantRegistration/saveResultVisibility`,
      method: 'PATCH',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name PatchPageantRegistrationHeadShot
   * @request PATCH:/PageantRegistration/saveHeadShot
   */
  patchPageantRegistrationHeadShot = (
    data: PictureModel,
    query?: {
      /** @format int32 */
      pageantRegistrationId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<RegisteredPageantContestantModelResponseWrapper, any>({
      path: `/PageantRegistration/saveHeadShot`,
      method: 'PATCH',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name FindAgeGroup
   * @request PATCH:/PageantRegistration/findAgeGroup
   */
  findAgeGroup = (
    query?: {
      /** @format int32 */
      pageantId?: number;
      /** @format date-time */
      birthday?: string;
      takenFallback?: boolean;
      /** @format int32 */
      genderId?: number;
      moveUpAgeGroup?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAgeGroupBaseModel, any>({
      path: `/PageantRegistration/findAgeGroup`,
      method: 'PATCH',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name SaveAgeGroup
   * @request PATCH:/PageantRegistration/saveAgeGroup
   */
  saveAgeGroup = (
    query?: {
      /** @format int32 */
      pageantRegistrationId?: number;
      /** @format int32 */
      pageantId?: number;
      /** @format date-time */
      birthday?: string;
      takenFallback?: boolean;
      /** @format int32 */
      genderId?: number;
      moveUpAgeGroup?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/PageantRegistration/saveAgeGroup`,
      method: 'PATCH',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantRegistration
   * @name UpdateRegistrationFields
   * @request PATCH:/PageantRegistration/updateFields
   */
  updateRegistrationFields = (data: UpdateFieldsRequest, params: RequestParams = {}) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/PageantRegistration/updateFields`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
